import { GET_ESSN_KEY, REGISTER_SERIAL_NUMBER } from '~/constants/APIs'
import { IRegisterSerialNumber } from '~/models'
import axiosClient from './axiosClient'

export const registerserialnumberApis = {
  getEssn: () => axiosClient.get(GET_ESSN_KEY) as unknown as IRegisterSerialNumber,

  registerSerial: (data: IRegisterSerialNumber) =>
    axiosClient.post(REGISTER_SERIAL_NUMBER, data)
}
